'use client'
import { createContext } from 'react'
import { AppConfig } from '@/root/shared-types/app-config/app-config'

export type AppConfigContextType = AppConfig & {
  formatMoney: (price: number, hideCurrency?: boolean) => string
}

export const AppConfigContext = createContext<AppConfigContextType>({} as AppConfigContextType)
